export default __webpack_public_path__ + "static/media/image2-3.4bf11592.png";